import { useState } from 'react';
import {
    Box,
    Text,
    Group,
    Stack,
    TextInput,
    UnstyledButton,
    Avatar,
    Badge,
    ActionIcon,
    ScrollArea,
    Button,
} from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';
import { getUserAvatarColour } from 'utils/helper';
import { logger } from 'utils/logger';

const AccountItem = ({ account, isActive, onClick }) => {
    const initials = account.name
        ? account.name
              .split(' ')
              .slice(0, 2)
              .map((w) => w.charAt(0).toUpperCase())
              .join('')
        : (account.code || '?').slice(0, 2).toUpperCase();

    const themeCol = getUserAvatarColour(initials.padEnd(2, initials[0] || 'A'));

    return (
        <UnstyledButton
            onClick={() => onClick(account)}
            sx={(theme) => ({
                display: 'block',
                width: '100%',
                padding: theme.spacing.sm,
                borderRadius: theme.radius.md,
                backgroundColor: isActive
                    ? theme.colorScheme === 'dark'
                        ? theme.colors.dark[6]
                        : theme.colors.brand[0]
                    : 'transparent',
                border: `1px solid ${
                    isActive
                        ? theme.colorScheme === 'dark'
                            ? theme.colors.dark[4]
                            : theme.colors.brand[3]
                        : 'transparent'
                }`,
                '&:hover': {
                    backgroundColor:
                        theme.colorScheme === 'dark'
                            ? theme.colors.dark[6]
                            : theme.colors.gray[0],
                },
            })}
        >
            <Group position="apart" noWrap>
                <Group noWrap>
                    <Avatar size="md" radius="md" color={themeCol} variant="filled">
                        {initials}
                    </Avatar>
                    <Stack spacing={2}>
                        <Text size="sm" weight={500} lineClamp={1}>
                            {account.name}
                        </Text>
                        {account.code && (
                            <Text size="xs" color="dimmed">
                                {account.code}
                            </Text>
                        )}
                    </Stack>
                </Group>
                {isActive && (
                    <Badge size="sm" variant="light" color="teal">
                        Active
                    </Badge>
                )}
            </Group>
        </UnstyledButton>
    );
};

const SwitchAccount = ({ accounts = [], currentAccount, onSwitch, onClose }) => {
    const [keyword, setKeyword] = useState('');

    const filtered = accounts.filter((acc) => {
        logger.log(acc)
        if (!keyword.trim()) return true;
        const term = keyword.toLowerCase();
        return (
            acc.name?.toLowerCase().includes(term) ||
            acc.code?.toLowerCase().includes(term)
        );
    });

    const handleSwitch = (account) => {
        if (account.code === currentAccount?.code) return;
        onSwitch(account);
    };

    logger.log(currentAccount, " CURRENT ACCOUNT")
    return (
        <Box>
            {/* Header */}
            <Box
                pl="lg"
                py="md"

                sx={(theme) => ({
                    borderBottom:
                        theme.colorScheme === 'dark'
                            ? `1px solid ${theme.colors.dark[4]}`
                            : `1px solid ${theme.colors.gray[2]}`,
                })}
            >
                <Group position="apart" align="center" pr={'sm'}>
                    <Box spacing="xs">
                        {/* <IconBuilding size={20} /> */}
                        <Text size="lg" weight={600}>
                            Switch Account
                        </Text>
                        <Text size={'xs'} color='dimmed'>Signed in as {currentAccount?.email}</Text>
                    </Box>
                    <ActionIcon onClick={onClose} variant="subtle" size="lg">
                        <IconX size={18} />
                    </ActionIcon>
                </Group>

                {/* {currentAccount && (
                    <Text size="xs" color="dimmed" mt={4}>
                        Currently viewing:{' '}
                        <Text component="span" weight={500} color="inherit">
                            {currentAccount.name}
                        </Text>
                    </Text>
                )} */}
            </Box>

            {/* Search */}
            <Box pt="md" pb="sm" px={'lg'}>
                <TextInput
                    placeholder="Search accounts..."
                    icon={<IconSearch size={14} />}
                    value={keyword}
                    onChange={(e) => setKeyword(e.currentTarget.value)}
                    rightSection={
                        keyword ? (
                            <ActionIcon size="xs" onClick={() => setKeyword('')} variant="transparent">
                                <IconX size={12} />
                            </ActionIcon>
                        ) : null
                    }
                />
            </Box>

            {/* Account List */}
            <ScrollArea style={{ maxHeight: 320 }} px={'lg'} >
                <Stack spacing={4} pb="md">
                    {filtered.length > 0 ? (
                        filtered.map((account) => (
                            <AccountItem
                                key={account.code}
                                account={account}
                                isActive={currentAccount?.code === account.code}
                                onClick={handleSwitch}
                            />
                        ))
                    ) : (
                        <Box py="xl" sx={{ textAlign: 'center' }}>
                            <Text size="sm" color="dimmed">
                                No accounts found
                            </Text>
                        </Box>
                    )}
                </Stack>
            </ScrollArea>

            <Group className='action-bar' position='apart' px={'lg'} pb={'sm'}>
                <Button variant='default' color='default'>Cancel</Button>
                <Button>Switch Account</Button>
            </Group>
        </Box>
    );
};

export default SwitchAccount;
